// Necessary to polyfill ECMAScript features and transpiled generator functions
// needed for asynchronous operations.
// See https://babeljs.io/docs/en/babel-polyfill for more information.
import 'core-js/stable';
import 'regenerator-runtime/runtime.js';
import '../main';
